// Tiny web logger. `debug`/`info` are noise in production and only fire in dev
// (Vite's import.meta.env.DEV); `warn`/`error` always fire so real failures stay
// visible. Prefer this over scattered console.* so gating lives in one place —
// notably malformed-SSE payloads and auth-callback failures log at `warn` rather
// than being silently swallowed.
const isDev = import.meta.env.DEV;

export const log = {
  debug: (...args: unknown[]): void => {
    if (isDev) console.debug(...args);
  },
  info: (...args: unknown[]): void => {
    if (isDev) console.info(...args);
  },
  warn: (...args: unknown[]): void => {
    console.warn(...args);
  },
  error: (...args: unknown[]): void => {
    console.error(...args);
  },
};
